/*
 * @Description: 
 * @Author: 
 * @Date: 2023-09-21 15:46:36
 * @LastEditTime: 2023-09-27 13:20:06
 * @LastEditors: 
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import * as echarts from 'echarts'
import dataV from '@jiaminghi/data-view'
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.use(dataV)
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js